import React from 'react'
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios'
import Swal from "sweetalert2/dist/sweetalert2";

import './portfolioImages.scss'

library.add( faBan );

export default function (props) {
    const { image, id, changeMainImg, closeModule } = props;
    return (
        <div className={'temporaryImage'}>
            <FontAwesomeIcon icon='ban' onClick={ el => { delImg(image.src, el, closeModule, changeMainImg)} } />
            <img src={'/images/portfolios/' + image.src } alt="" className='temporarySelectedImage' />
            <input
                type="radio"
                name="main"
                value={ id }
                className={ +image.checked === 1 ? 'checked': '' }
                onClick={el =>{ changeMain(el, changeMainImg)} }
            />
        </div>
    )
}

function changeMain (el, changeMainImg) {
    let th = el.target;
    if (th.classList.contains('checked')) return;
    document.querySelectorAll('.temporaryImage > input[type=radio]').forEach(el => {
        el.classList.remove('checked');
    });
    th.classList.add('checked');
    let image = th.previousSibling.src.split('/'),
        id = document.querySelector('#myOwnModule').dataset.id,
        src = image[image.length - 1];
    axios.post('/api/portfolio/changeMain', {id, src}).then(({ data }) => {
        const {message, result, id} = data;
        if (message === 'changed') {
            changeMainImg(id, result);
        }
    })
}

function delImg (src, el, closeModule, changeMainImg) {
    let temporaryImage = document.querySelectorAll('#myOwnModule #main .temporaryImage');
    let myModule = document.querySelector('#myOwnModule');
    if(temporaryImage.length === 1) {
        Swal.fire({
            title: 'Պորտֆոլիոն պետք է ունենա գոնե 1 նկար',
            text: 'Կարող եք ավելացնել նոր նկար ապա ջնջել այս մեկը',
            type: 'error'
        });
        myModule.classList.remove('openModule');
        myModule.dataset.id = '';
        document.removeEventListener('click', closeModule);
        return;
    }
    let parent = el.target.closest('.temporaryImage'),
        id = myModule.dataset.id,
        myInput = parent.querySelector('input');
    if(!myInput.classList.contains('checked')){
        axios.post(`/api/portfolio/delImageBySrc`, {src, id}).then( ({ data }) => {
            if(data.message === 'Photo deleted') {
                changeMainImg(id, data.result)
            }
        })
    }
    else {
        let newMainTag = (parent.previousSibling)? parent.previousSibling: parent.nextSibling;
        let newMainSrc = newMainTag.querySelector('img').src.split('/');
        let newSrc = newMainSrc[newMainSrc.length - 1];
        axios.post(`/api/portfolio/delImageById`, {id, src, newSrc}).then( ({ data }) => {
            if(data.message === 'Photo deleted') {
                changeMainImg(id, data.result);
            }
        })
    }
    Swal.fire({
        title: 'Նկարն հաջողությամբ ջնջվել է',
        type: 'success'
    });
    myModule.classList.remove('openModule');
    myModule.dataset.id = '';
    document.removeEventListener('click', closeModule);


}
